var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", { staticClass: "hint-wrapper" }, [
    _vm._v(_vm._s(_vm.getLabel) + " "),
    _c("img", {
      attrs: {
        src: require(`@/common/assets/icons/help-yellow.svg`),
        alt: "hint"
      }
    }),
    _c("div", { staticClass: "hint-container" }, [_vm._t("hint")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }